<template>
  <div id="page-product-details">
    <section-form
        v-model="model"
        ref="form"
        :loading="loading"
        card-title="Details"
    />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
              class="my-4"
              @click="$router.push({ name: 'facilities.sections.list' })"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
              :disabled="loading"
              class="my-4"
              color="light"
              @click="save"
          >
            Save
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import NotificationMixin from "@/components/mixins/NotificationMixin";
import SectionForm from '@/views/pages/facilities/sections/SectionForm';
import ViewModelMixin from '@/components/mixins/ViewModelMixin';
import SaveModelMixin from "../../../../components/mixins/SaveModelMixin";

export default {
  name: "SectionEdit",
  components: {
    SectionForm,
  },
  mixins: [ViewModelMixin, NotificationMixin, SaveModelMixin],
  data() {
    return {
      loading: false,
      modelEntity: this.$api.facilities.sections,
      dates: ['ExpiryDate', 'InceptionDate'],
      references: ['ClassOfRisk_FK', 'SectionClassificationType_FK'],
    };
  },
  computed: {
    id() {
      return this.$route.params.sectionId;
    },
    title() {
      if (!this.model.Section) {
        return '';
      }

      return '<h2>Section: ' + this.model.Section + '</h2>';
    }
  },
  methods: {
    async save() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      this.loading = true;
      const params = this.getParams();
      delete params.Facility_FK;
      delete params.id;

      try {
        const {data} = await this.$api.facilities.sections.update(this.id, params);
        this.notifySuccess('Section updated');
        await this.$router.push({name: 'facilities.sections.view'});
      } catch (e) {
        this.notifyError('Section failed to be update');
        console.error(e)
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>

</style>
